import { useTranslation } from 'react-i18next'

import useCartModal from '@features/cart/hooks/useCartModal'
import { useCartStore } from '@features/cart/model/useCartStore'

import { URL_CART } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'



interface CartLinkProps {
  className?: string;
  useModal?: boolean;
}

export default function CartLink (props: CartLinkProps) {
  const { t: tc } = useTranslation('common')
  const { className, useModal = true } = props
  const { getTotalQuantity, cartInfoData: cartInfo } = useCartStore()
  const { openCartModal } = useCartModal()

  const COUNT = getTotalQuantity()
  const total = cartInfo?.totals?.total as number

  const handleClick = () => {
    if (useModal) {
      openCartModal()
    }
  }

  return (
    <Button
      className={cn(className, styles.link)}
      theme="grey"
      size="large"
      to={useModal ? undefined : URL_CART}
      onClick={useModal ? handleClick : undefined}
    >
      {!COUNT && (
        <>
          <img
            src="/icons/cart.svg"
            alt=""
            loading="lazy"
            fetchPriority="low"
          />
          {tc('cart.button')}
        </>
      )}

      {!!COUNT && total && (
        <>
          <img
            src="/icons/shopping-bag.svg"
            alt=""
            loading="lazy"
            fetchPriority="low"
          />
          {formatPrice(total as number)}
        </>
      )}

      {!!COUNT && <span className={styles.link__count}> {COUNT}</span>}
    </Button>
  )
}
